export default "__VITE_ASSET__HDHuQed6__"